module.exports = __webpack_public_path__ + "static/pinkfloralbum2-13e3bab6321845c55fcb1750ec5ac404.jpeg";